import { render, staticRenderFns } from "./_Head.vue?vue&type=template&id=ed2f865c&scoped=true&"
import script from "./_Head.vue?vue&type=script&lang=js&"
export * from "./_Head.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed2f865c",
  null
  
)

export default component.exports